import depTeamRoad from '@src/pages/HR/depTeamRoad';
export default {
    result: {
        team: depTeamRoad(),
    },
    models: {
        depTeamRoad,
    },
};
